import React from 'react';
import PropTypes from 'prop-types';
import './LoadingBarPercentageSetupPunchLaughs.css';

const LoadingBarPercentageSetupPunchLaughs = React.memo(({ setupPercentage, punchlinePercentage, taglinePercentage, laughPercentage }) => {
  // Ensure that all percentages are numbers
  const setup = Number(setupPercentage);
  const punchline = Number(punchlinePercentage);
  const tagline = Number(taglinePercentage);
  const laugh = Number(laughPercentage);

  // Handle cases where laugh is 0 or NaN
  const comedianTalkingPercentage = (laugh === 0 || isNaN(laugh)) ? 100 : 100 - laugh;

  const setupWidthPercentage = (setup / 100) * comedianTalkingPercentage;
  const punchlineWidthPercentage = (punchline / 100) * comedianTalkingPercentage;
  const taglineWidthPercentage = (tagline / 100) * comedianTalkingPercentage;
  const laughWidthPercentage = laugh;

  return (
    <div className="loading-bar-container">
      {/* Only render the setup bar if setupPercentage is greater than 0 */}
      {setupWidthPercentage > 0 && (
        <div
          className="loading-bar-setup"
          style={{ width: `${setupWidthPercentage}%` }}
          title={`Setup: ${setupWidthPercentage.toFixed(1)}%`}
        >
          <span className="loading-bar-text">{`${setupWidthPercentage.toFixed(1)}%`}</span>
        </div>
      )}

      {/* Only render the punchline bar if punchlinePercentage is greater than 0 */}
      {punchlineWidthPercentage > 0 && (
        <div
          className="loading-bar-punchline"
          style={{ width: `${punchlineWidthPercentage}%` }}
          title={`Punchline: ${punchlineWidthPercentage.toFixed(1)}%`}
        >
          <span className="loading-bar-text">{`${punchlineWidthPercentage.toFixed(1)}%`}</span>
        </div>
      )}

      {/* Only render the tagline bar if taglinePercentage is greater than 0 */}
      {tagline > 0 && (
        <div
          className="loading-bar-tagline"
          style={{ width: `${taglineWidthPercentage}%` }}
          title={`Tagline: ${taglineWidthPercentage.toFixed(1)}%`}
        >
          <span className="loading-bar-text">{`${taglineWidthPercentage.toFixed(1)}%`}</span>
        </div>
      )}

      {/* Only render the laughter bar if laughPercentage is greater than 0 */}
      {laugh > 0 && (
        <div
          className="loading-bar-laughter"
          style={{ width: `${laughWidthPercentage}%` }}
          title={`Laughter: ${laughWidthPercentage.toFixed(1)}%`}
        >
          <span className="loading-bar-text">{`${laughWidthPercentage.toFixed(1)}%`}</span>
        </div>
      )}
    </div>
  );
});

// Use PropTypes to ensure only numbers are passed as props
LoadingBarPercentageSetupPunchLaughs.propTypes = {
  setupPercentage: PropTypes.number.isRequired,
  punchlinePercentage: PropTypes.number.isRequired,
  taglinePercentage: PropTypes.number.isRequired,
  laughPercentage: PropTypes.number.isRequired,
};

export default LoadingBarPercentageSetupPunchLaughs;
